export default __webpack_public_path__ + "static/tablet-41c7ea01bc16c2e3f940e5634a1848fe.png";